/* unplugin-vue-components disabled */
import Question from './question'
import InputFiles from './input-files.vue'
import $global from 'stores/global'
import {create_store} from 'stores/files'
import {DOCUMENT} from 'consts/ftypes.js'
import InputControls from './input-controls.vue'
import {computed} from 'vue'
import {API2_CHATS} from 'consts/api2'
import Rest from 'utils/rest'

const MAX_UPLOADS = 5

const __default__ = {
  components: {InputFiles, InputControls, Question},
  mixins: [ModelValue(String)],
  provide() {
    return {
      di_recording: computed({
        get: () => this.recording,
        set: recording => this.recording = recording
      }),
      di_caps: computed(() => this.caps)
    }
  },
  props: {
    placeholder: {type: String, default: 'Ask anything, or type / to run a skill…'},
    description: {type: String, default: ''},
    generating: {type: Boolean, default: false},
    controls: {type: Boolean, default: false},
    expanded: {type: Boolean, default: false},
    question: {type: Object, default: undefined},
    footnote: {type: Boolean, default: true},
  },
  emits: ['stop', 'regenerate', 'resize', 'caps-loaded'],
  data() {
    return {
      deep: false,
      focused: false,
      f_store: create_store(DOCUMENT.type),
      chat_height: 0,
      recording: false,
      caps: undefined,
      caps_loading: true,
      rest: new Rest(),
      submitting: false
    }
  },
  computed:{
    c_placeholder() {
      if (this.question_input) return 'Or tell me what you need…'
      return this.placeholder
    },
    question_input() {
      return !!this.question?.can_input
    },
    uploads_enabled() {
      return !!(this.$responsive.desktop && $global.fileUploadEnabled)
    },
    can_upload() {
      const files_len = this.f_store.files.length
      const uploads_len = this.f_store?.uploads.length
      return (files_len + uploads_len) < MAX_UPLOADS
    },
    can_push() {
      if (this.recording || this.submitting) return false
      if (this.question_input) return !!this.value?.length
      if (this.generating) return false
      const is_processing = this.f_store.files.some(x => x.processing)
      const is_uploads = this.f_store.uploads.length === 0
      return !!(this.value?.length && !is_processing && is_uploads)
    }
  },
  watch: {
    generating(value) {
      if (value && this.submitting) this.resetInput()
    }
  },
  mounted() {
    this.fetchCaps()
  },
  beforeUnmount() {
    this.rest.abortAll()
  },
  methods: {
    setCommand(command) {
      this.$refs.controls.setCommand(command)
    },
    async fetchCaps() {
      this.caps = await this.rest.get(`${API2_CHATS}/caps`)
      this.caps_loading = false
      this.$emit('caps-loaded', this.caps)
    },
    setHeight(){
      if (!this.$refs.absolute) {
        // TODO: fast fix before release. need to fix it inside v-resize and check in other places
        return
      }
      this.chat_height = `${this.$refs.absolute.offsetHeight}px`
      this.$nextTick(() => this.$emit('resize'))
    },
    focus(ev) {
      if (this.recording) return
      this.$refs.question?.disableTimer()
      this.$refs.controls.focus(ev)
    },
    blur(){
      this.$refs.controls.blur()
    },
    uploadFile(){
      this.$refs.uploads.uploadFile()
    },

    onPush(event){
      if (!this.can_push) return
    
      const params = {
        text: /^\s*[/@]/.test(this.value) 
          ? this.value : $utils.str.capitalizeSentences(this.value)
      }
      // in case of question
      if (this.question_input) {
        this.onAnswerAI(params)
        return
      }
      if (this.f_store.files.length) {
        params.files = this.f_store.files.map(x => x.id)
      }
      this.blur()
      this.submitting = true
      this.$emit('regenerate', params)
    },
    resetInput(clearFiles = true) {
      this.value = ''
      this.blur()
      if (clearFiles) this.f_store = create_store(DOCUMENT.type)
      this.submitting = false
    },
    onStop(){
      this.$emit('stop')
    },
    onAnswerAI(chat_query){
      this.$dispatch('answer-ai', {...chat_query, state: this.question.state})
      this.resetInput(false)
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "16679840-chat_height": (_ctx.chat_height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__